import { jsx as _jsx } from "react/jsx-runtime";
import { LogoIcon } from '@lichtblick/icons/svg/logo/logo';
import classNames from 'classnames';
import styles from './logo.module.scss';
export const Logo = ()=>/*#__PURE__*/ _jsx(LogoIcon, {
        className: classNames('logo', styles.logo)
    });

//# sourceMappingURL=logo.js.map